import { Injectable } from '@angular/core';
import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { IPreCadastro } from '../models/pre_cadastro.model';

@Injectable()
export class PreCadastroService extends EntityService<IPreCadastro> {
  constructor(protected configService: ConfigService) {
    super(
      {
        urlBackend: configService.backendURL,
        baseEntityEndPoint: 'pre_cadastro'
      }
    );
  }
}
